<div *ngIf="!loading && empty" class="text-16-800-dark centered">
  {{ emptyLabel || 'NO_RECORDS' | translate }}
</div>
<div *ngIf="loading">
  <div class="progressbar-outer"><div class="progressbar-inner"></div></div>
  <div class="text-16-800-dark centered">{{ 'LOADING' | translate }}...</div>
</div>
